var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col overflow-hidden border-solid rounded-lg bg-whiteOverride border-1 border-border",class:{ 'opacity-25': _vm.disabled }},[_c('div',{staticClass:"w-full min-h-ml bg-offWhite px-lg"},[_vm._t("header")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }